var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessengerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 717",
    x: 1.75,
    y: 5.75,
    width: 27.5,
    height: 19.5,
    rx: 1.25,
    stroke: "#4A4A4A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 38",
    d: "M2 9L10.617 15.383M29 9L20.383 15.383M2 24L10.617 15.383M10.617 15.383L14.3095 18.1182C15.0167 18.642 15.9833 18.642 16.6905 18.1182L20.383 15.383M20.383 15.383L29 24",
    stroke: "#4A4A4A",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerIcon);
export default __webpack_public_path__ + "static/media/messenger-icon.d5052aa4205bb54a160ea4e42d8c1e38.svg";
export { ForwardRef as ReactComponent };